import React from 'react'
import PropTypes from 'prop-types'
import {useIntl} from 'react-intl'
import {Box, Image, Stack} from '@salesforce/retail-react-app/app/components/shared/ui'

import Map from './map'
import {getUrl} from '../../../../utils/cloudinary-utils'

const Footer = ({storeDetails}) => {
    const intl = useIntl()

    return (
        <Stack
            direction={{base: 'column', lg: 'row'}}
            gap="20px"
            alignItems="start"
            marginTop="40px"
        >
            <Box width={{base: '100%', lg: 'calc(50% - 10px)'}} aspectRatio="1/1">
                <Map store={storeDetails} />
            </Box>

            <Box width={{base: '100%', lg: 'calc(50% - 10px)'}} aspectRatio="1/1">
                <Image
                    alt={
                        storeDetails.name ||
                        intl.formatMessage({
                            id: 'select_store_modal.store_image',
                            defaultMessage: 'Store Image'
                        })
                    }
                    width="100%"
                    height="100%"
                    objectFit="cover"
                    src={
                        storeDetails?.image || getUrl('UIImages/images/interface/ks-store-logo.jpg')
                    }
                />
            </Box>
        </Stack>
    )
}

Footer.propTypes = {
    storeDetails: PropTypes.shape({
        name: PropTypes.string,
        image: PropTypes.string
    })
}

export default Footer
